export enum BannerVariant {
  BANNER_VARIANT_UNKNOWN = 'BANNER_VARIANT_UNKNOWN',
  /**
   * image | text | (button)  Web only
   */
  DEFAULT_IMAGE_TEXT_BANNER = 'DEFAULT_IMAGE_TEXT_BANNER',
  /**
   * text | Image/ImageList  Web only
   */
  TEXT_IMAGE_BANNER = 'TEXT_IMAGE_BANNER',
  /**
   * / Takes up the full width without any margins or rounded corners
   */
  IMAGE_BANNER = 'IMAGE_BANNER',
  /**
   * This value replaces IMAGE_BANNER. It is currently only used by mobile platforms
   * Figma reference here: https://www.figma.com/file/s7VxgVsNoO1smpdecnUYoN/Slate-Core-Components?node-id=31899%3A4152&mode=dev
   */
  ANNOUNCEMENT_BANNER = 'ANNOUNCEMENT_BANNER',
  /**
   * Uses a similar view to ANNOUNCEMENT_BANNER but constraints the content width
   * to 70% on mweb / apps
   * Figma reference here: https://www.figma.com/file/3I5Wiw0SQkHAN4zrDLpaWf/Tiered-browse-framework?type=design&node-id=1783-166418&mode=design&t=JxlAyr5QClX4v65D-4
   */
  ANNOUNCEMENT_BANNER_CONTENT_WIDTH_CONSTRAINED = 'ANNOUNCEMENT_BANNER_CONTENT_WIDTH_CONSTRAINED',
  /**
   * Text with a CTA and optional icons as prefix. Intended for full width banners usually at the top of the page.
   */
  SITE_TEXT_BANNER = 'SITE_TEXT_BANNER',
  /**
   * Uses a similar view to TEXT_IMAGE_BANNER, but for usage in vertical modals
   */
  VERTICAL_MODAL_TEXT_IMAGE_BANNER = 'VERTICAL_MODAL_TEXT_IMAGE_BANNER',
  /**
   * Uses for text and image banner on mobile clients
   * Figma reference here: https://www.figma.com/design/wj1A27NN4LZsPDpkIJkVev/FOI-in-app?node-id=131-3851&t=T40mcwLojptcCZKq-4
   */
  EDITORIAL_TEXT_IMAGE_BANNER = 'EDITORIAL_TEXT_IMAGE_BANNER',
  /**
   * Takes up full width without any margins, corners or any padding
   */
  INLINE_BANNER = 'INLINE_BANNER',
}
